import { render, staticRenderFns } from "./NwxPicklist.vue?vue&type=template&id=45499d45&scoped=true"
import script from "./NwxPicklist.vue?vue&type=script&lang=js"
export * from "./NwxPicklist.vue?vue&type=script&lang=js"
import style0 from "./NwxPicklist.vue?vue&type=style&index=0&id=45499d45&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45499d45",
  null
  
)

export default component.exports